import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, click } from '@tracking';

import { MOMENT_THAT_MATTERS_POSTER_IMAGE_URL, MOMENT_THAT_MATTERS_VIDEO_URL } from './constant';

const MomentThatMatter = () => {
  const { trackEvent } = useEventTracking();
  return (
    <div className="mt-112 px-12 pb-80">
      <div className="m-auto max-w-container-lg">
        <h3 className="m-0 border-0 border-b border-solid border-grayscale-beige pb-32 font-suisse-screen text-headline-lg sm:text-headline-alt-lg">
          Moment That Matters
        </h3>
        <div className="aspect-[16/9] w-full md:px-72">
          <video
            onPlay={() => trackEvent(click({ clickTarget: ClickTarget.Video }))}
            className="h-full w-full"
            poster={MOMENT_THAT_MATTERS_POSTER_IMAGE_URL}
            preload="metadata"
            src={MOMENT_THAT_MATTERS_VIDEO_URL}
            controls
            playsInline
          />
        </div>
      </div>
    </div>
  );
};

export default MomentThatMatter;
